<template>
  <portal-context-cta
    v-if="!showCta"
    modifier="_pts _pbs"
  />
  <div v-else>
    <slot />
  </div>
</template>

<script>
  import PortalContextCta from '@organisms/PortalContextCTA'
  import { useGroupSelector } from '@composables/useGroupSelector';
  import { computed } from '@vue/composition-api';
  import { useRoute } from '@vue3shims';
  import { onBeforeMount } from '@vue/composition-api';
  export default {
    setup() {
      const route = useRoute();
      const { hasSelectedAll, hasSelectedParentGroup, hasSelection } = useGroupSelector();
      const showCta = computed(() => {
        if(route.name === 'billing-manage-auto-payment-methods') {
          return hasSelectedAll.value;
        }
        else if(route.name === 'billing-overview' && route.name === 'billing-payment-history') {
          return hasSelectedParentGroup.value;
        }
        return hasSelection.value;
      });

      onBeforeMount(() => {
        console.log(`showCta`, showCta.value);
      });

      return {
        showCta,
      }
    },
    components: {
      PortalContextCta
    },
  }
</script>
